import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PhoneNumber, PhoneNumberType } from '@models/booking.models';
import { CountryPhoneCode } from '@models/cms/app.model';
import { PassengerForm, PrimaryContactForm } from '@models/form/form.models';
import { ContactRequest } from '@models/requests/contact-request.model';
import { PassengerAddress } from '@models/requests/passenger-update-request.model';
import { ApiResponse } from '@models/responses/api-response.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { createPhoneNumberFromParts } from '@utils/data-utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private static readonly CONTROLLER_ROOT = 'v1/contact';

  constructor(private httpClient: HttpClient) {}

  addPrimaryContact(
    primaryContact: ContactRequest,
  ): Observable<ApiResponse<null>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${ContactService.CONTROLLER_ROOT}/primary`;
    return this.httpClient.post<ApiResponse<null>>(endpoint, primaryContact);
  }

  updatePrimaryContact(
    primaryContact: ContactRequest,
  ): Observable<ApiResponse<null>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${ContactService.CONTROLLER_ROOT}/primary`;
    return this.httpClient.put<ApiResponse<null>>(endpoint, primaryContact);
  }

  transformFormDataToContactRequest(
    form: PassengerForm | PrimaryContactForm,
    phoneCodes: CountryPhoneCode[],
    cultureCode: string,
    customerNumber?: string,
  ): ContactRequest {
    const phoneNumbers: PhoneNumber[] = [];
    const addresses: PassengerAddress[] = [];
    const address: PassengerAddress = {};

    let phone: string | null = null;
    if (form.phone) {
      const phoneCodeNumber = phoneCodes.find(
        (code) => code.countryCode === form.phoneCode,
      )?.value;
      phone = createPhoneNumberFromParts(phoneCodeNumber, form.phone);
    }

    if (phone) {
      phoneNumbers.push({
        type: PhoneNumberType.Home,
        number: phone,
      });
      address.phone = phone;
    }

    if (form.email) {
      address.emailAddress = form.email;
    }

    if (address.phone || address.emailAddress) {
      addresses.push(address);
    }

    return {
      cultureCode,
      customerNumber,
      emailAddress: address.emailAddress,
      name: {
        first: form.firstName,
        middle: form.middleName || undefined,
        last: form.lastName,
        suffix: form.suffix || undefined,
      },
      phoneNumbers,
    };
  }
}
